// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4314":"3f4c4ef8","4872":"3f4c4ef8","5369":"3f4c4ef8","7955":"3f4c4ef8"}[chunkId] + ".chunk.css";
};